module.exports = __webpack_public_path__ + "img/7_1.900bb535.png";